import { render, staticRenderFns } from "./TeamEditor.vue?vue&type=template&id=aa4a1a04&"
import script from "./TeamEditor.vue?vue&type=script&lang=js&"
export * from "./TeamEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports